module.exports = __webpack_public_path__ + "static/media/sk-flag.cd89f9b8.svg";